import { render, staticRenderFns } from "./MedRecordHome.vue?vue&type=template&id=477a909c"
import script from "./MedRecordHome.vue?vue&type=script&lang=js"
export * from "./MedRecordHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports